/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Warning/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Warning({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Warning",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Warning.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 12"
 style={{'--as-1-15w3Cf': alignSelf,'--mt-2-15w3Cf': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-15w3Cf': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-15w3Cf': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-15w3Cf': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-15w3Cf': opacity,'--w-10-15w3Cf': typeof width === 'number' ? `${width}px` : width,'--h-11-15w3Cf': typeof height === 'number' ? `${height}px` : height,'--f-12-15w3Cf': fill,'--a-7-15w3Cf': isAnimated ? animation : "none",'--sd-8-15w3Cf': isAnimated ? strokeDashoffset : 0,'--sd-9-15w3Cf': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Warning.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M.394 6.952a1.346 1.346 0 010-1.903L5.05.394a1.346 1.346 0 011.903 0l4.655 4.655a1.346 1.346 0 010 1.903l-4.655 4.655a1.346 1.346 0 01-1.903 0L.394 6.952zM6.001 2.68c.355 0 .643.288.643.643v2.786a.643.643 0 01-1.286 0V3.322c0-.355.288-.643.643-.643zm.857 5.786a.857.857 0 11-1.714 0 .857.857 0 011.714 0z"
 style={{'--f-12-15w3Cf': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}